import PropTypes from "prop-types";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { PrimaryButton, Text } from "@artprov/design-system";

export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={({ error }) => <Fallback error={error} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

function Fallback({ error }) {
  useEffect(() => {
    Sentry.captureException(error, {
      mechanism: { handled: true, type: "React-ErrorBoundary" },
    });
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center flex-1 bg-tertiary-100 px-4 text-center">
      <Text variant="h4">Se produjo un error en el sistema</Text>

      <p className="text-xl font-semibold mb-2">
        Algo no funcionó correctamente.
      </p>

      <p className="text-zinc-600 mb-6">Intentá recargar la página.</p>

      <PrimaryButton onClick={() => window.location.reload()}>
        Recargar
      </PrimaryButton>
    </div>
  );
}

Fallback.propTypes = {
  error: PropTypes.instanceOf(Error),
};

